module.exports = __webpack_public_path__ + "img/gergilin.3da8454d.png";